import { render, staticRenderFns } from "./indexProjects.vue?vue&type=template&id=6454d9fe&scoped=true"
import script from "./indexProjects.vue?vue&type=script&lang=js"
export * from "./indexProjects.vue?vue&type=script&lang=js"
import style0 from "./indexProjects.vue?vue&type=style&index=0&id=6454d9fe&prod&scoped=true&lang=css"
import style1 from "./indexProjects.vue?vue&type=style&index=1&id=6454d9fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6454d9fe",
  null
  
)

export default component.exports